import React, { useEffect } from "react";
import "./styles.scss";
import "./mobile.scss";
import { NewsCard, NewsGroup } from "../../../../components";
import { withRouter } from "react-router-dom";
import { getCategoryById } from "../../../CreateNewItem/CreateNewCategory/service/category.service";
import { getNewsByCategoryPage } from "../../../news/service/news.service";
import { getLanguage } from "../../../../utils/environment";

// const categoryId = process.env.REACT_APP_MAIN_NEWS;
const pageCount = process.env.REACT_APP_MAIN_P_COUNT;
const lan = getLanguage();

const Index = (props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [news, setNews] = React.useState([]);
  const [menu, setMenu] = React.useState("");

  const handleChangeTag = (tag) => {
    props.setTagData(tag);
  };

  useEffect(() => {
    if (props.active && news?.length === 0) {
      setIsLoading(true);

      getCategoryById(props.categoryId)
        .then((res) => {
          if (res?.data) {
            setMenu(res.data);
            return getNewsByCategoryPage(props.categoryId, pageCount, lan);
          } else {
            setNews([]);
            return null; // stop the chain
          }
        })
        .then((response) => {
          if (response?.data) {
            setNews(response.data.news);
          } else if (response !== null) {
            setNews([]);
          }
        })
        .catch((error) => {
          console.log({ error });
          setNews([]);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [props.categoryId && props.active]);

  return (
    <>
      {(news?.length > 0 || isLoading) && (
        <NewsGroup
          data={{
            titleName: menu?.name?.[lan] || "",
            linkName:
              lan === "en"
                ? "More " + menu?.name?.[lan]
                : "තවත් " + menu?.name?.[lan],
          }}
          onClickViewNews={() => {
            props.history.push("/" + props.categoryId);
            props.setMenuName(props.categoryId);
          }}
        >
          {isLoading && <NewsCard data={{ type: "loading", isBorder: true }} />}
          {!isLoading &&
            // news.map((item, index) => {
            news.slice(0, 1).map((item, index) => {
              // Check if the item has updates
              const hasUpdates =
                Array.isArray(item.updates) && item.updates.length > 0;

              // If updates exist, use the latest update (or modify as needed)
              const displayItem = hasUpdates
                ? { ...item, ...item.updates[item.updates.length - 1] }
                : item;

              return (
                <React.Fragment key={index}>
                  <NewsCard
                    key={index}
                    data={{
                      type: "extralarge",
                      isBorder: true,
                      isUpdate: hasUpdates,
                    }}
                    item={displayItem}
                    onClick={() => {
                      if (displayItem?.keywords?.[lan]) {
                        props.history.push(
                          `/${displayItem?.keywords?.[lan]}/${displayItem?.news_id}`
                        );
                      } else {
                        const generatedSlug = item?.title?.[lan]
                          ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                          ?.replace(/\//g, "")
                          ?.replace(/\s*-\s*/g, " ")
                          ?.trim()
                          .split(/\s+/)
                          .slice(0, 5)
                          .join("-")
                          .replace(/-+/g, "-");
                        props.history.push(
                          `/${generatedSlug}/${displayItem?.news_id}`
                        );
                      }
                    }}
                  />
                </React.Fragment>
              );
            })}

          <div className={"more-hot-news"}>
            {!isLoading &&
              // except  first item, show the rest of the items
              news.slice(1, news?.length).map((item, index) => {
                // news.map((item, index) => {
                // Check if the item has updates
                const hasUpdates =
                  Array.isArray(item.updates) && item.updates.length > 0;

                // If updates exist, use the latest update (or modify as needed)
                const displayItem = hasUpdates
                  ? { ...item, ...item.updates[item.updates.length - 1] }
                  : item;

                return (
                  <React.Fragment key={index}>
                    <NewsCard
                      key={index}
                      data={{
                        type: "extrasmall",
                        isBorder: false,
                        isUpdate: hasUpdates,
                      }}
                      item={displayItem}
                      onClick={() => {
                        // props.history.push("/news-view");
                        if (displayItem?.keywords?.[lan]) {
                          props.history.push(
                            `/${displayItem?.keywords?.[lan]}/${displayItem?.news_id}`
                          );
                        } else {
                          const generatedSlug = item?.title?.[lan]
                            ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                            ?.replace(/\//g, "")
                            ?.replace(/\s*-\s*/g, " ")
                            ?.trim()
                            .split(/\s+/)
                            .slice(0, 5)
                            .join("-")
                            .replace(/-+/g, "-");
                          props.history.push(
                            `/${generatedSlug}/${displayItem?.news_id}`
                          );
                        }
                      }}
                      onChangeTag={handleChangeTag}
                    />
                  </React.Fragment>
                );
              })}
          </div>
        </NewsGroup>
      )}
    </>
  );
};
export default withRouter(Index);
// export default Index;
